import { AnredeArtApi } from "../../../../../shared/models/generated/InterfacesAnredeArtApi";
import { AppUtils } from '../../../../../shared/utils/index';

export class CorrectionRequestApi {

	private tankstelleID: string;
	public get TankstelleID(): string {
		return this.tankstelleID;
	}
	public set TankstelleID(value: string) {
		this.tankstelleID = value;
	}

	private entdecktAm: string;
	public get EntdecktAm(): string {
		return this.entdecktAm;
	}
	public set EntdecktAm(value: string) {
		this.entdecktAm = value;
	}

	private entdecktUm: string;
	public get EntdecktUm(): string {
		return this.entdecktUm;
	}
	public set EntdecktUm(value: string) {
		this.entdecktUm = value;
	}

	private anredeKennzeichen: AnredeArtApi;
	public get AnredeKennzeichen(): AnredeArtApi {
		return this.anredeKennzeichen;
	}
	public set AnredeKennzeichen(value: AnredeArtApi) {
		this.anredeKennzeichen = value;
	}

	private vorname: string;
	public get Vorname(): string {
		return this.vorname;
	}
	public set Vorname(value: string) {
		this.vorname = value;
	}

	private nachname: string;
	public get Nachname(): string {
		return this.nachname;
	}
	public set Nachname(value: string) {
		this.nachname = value;
	}

	private postleitzahl: string;
	public get Postleitzahl(): string {
		return this.postleitzahl;
	}
	public set Postleitzahl(value: string) {
		this.postleitzahl = value;
	}

	private strasseHausnummer: string;
	public get StrasseHausnummer(): string {
		return this.strasseHausnummer;
	}
	public set StrasseHausnummer(value: string) {
		this.strasseHausnummer = value;
	}

	private ort: string;
	public get Ort(): string {
		return this.ort;
	}
	public set Ort(value: string) {
		this.ort = value;
	}

	private email: string;
	public get Email(): string {
		return this.email;
	}
	public set Email(value: string) {
		this.email = value;
	}

	constructor(initialProperties?: Partial<CorrectionRequestApi>) {
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	public static createFromObject(dataObject: { [key: string]: any }): CorrectionRequestApi {
		return AppUtils.Helper.createFromMap(dataObject, CorrectionRequestApi);
	}

	public toRequestObject(): { [key: string]: any } {
		return {
			TankstelleID: this.TankstelleID,
			EntdecktAm: this.EntdecktAm,
			EntdecktUm: this.EntdecktUm,
			AnredeKennzeichen: this.AnredeKennzeichen,
			Vorname: this.Vorname,
			Nachname: this.Nachname,
			StrasseHausnummer: this.StrasseHausnummer,
			Ort: this.Ort,
			Postleitzahl: this.Postleitzahl,
			Email: this.Email
		} as { [key: string]: any };
	}
}